import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { classNames } from "primereact/utils";
import { find, isEmpty } from "lodash";
import { request } from "../../utils/Request";
import { useSidebar } from "../../contexts/SidebarContext";
import { useAppMenuModel } from "./useAppMenuModel";
import AppSidebarMenu from "./AppSidebarMenu";

const AppSidebar = () => {
    const { isMini, isExpanded, isMobile, mobileOpen } = useSidebar();
    const menuModel = useAppMenuModel();
    const [logo, setLogo] = useState<string>();
    const [mobileLogo, setMobileLogo] = useState<string>();

    useEffect(() => {
        const loadSettings = async () => {
            try {
                const response = await request({
                    url: `/auth/setting`,
                    params: {
                        settings: ["logo", "mobile_logo"],
                    },
                });

                const { data } = response.data;
                const logoSetting = find(data, { title: "logo" });
                const mobileLogoSetting = find(data, { title: "mobile_logo" });

                if (!isEmpty(logoSetting)) {
                    setLogo(logoSetting.value);
                }

                if (!isEmpty(mobileLogoSetting)) {
                    setMobileLogo(mobileLogoSetting.value);
                }
            } catch (error) {
                // Keep fallback logos when settings fail.
            }
        };

        loadSettings();
    }, []);

    const fullLogoSrc = logo
        ? `${process.env.REACT_APP_DOCUMENT_URL}/${logo}`
        : `${process.env.REACT_APP_API_URL}/logo/alcolm-logo-blue.png`;

    const miniLogoSrc = mobileLogo
        ? `${process.env.REACT_APP_DOCUMENT_URL}/${mobileLogo}`
        : fullLogoSrc;

    return (
        <aside
            className={classNames("app-sidebar", {
                "app-sidebar--expanded": isExpanded || (isMobile && mobileOpen),
                "app-sidebar--mini": isMini,
                "app-sidebar--mobile": isMobile,
                "app-sidebar--mobile-open": isMobile && mobileOpen,
            })}
            aria-hidden={isMobile && !mobileOpen}
        >
            <div className="app-sidebar__inner">
                <div className="app-sidebar__header">
                    <Link to="/" className="app-sidebar__brand">
                        <img
                            className="app-sidebar__brand-logo app-sidebar__brand-logo--full"
                            src={fullLogoSrc}
                            alt="Logo"
                            width={180}
                        />
                        <img
                            className="app-sidebar__brand-logo app-sidebar__brand-logo--mini"
                            src={miniLogoSrc}
                            alt="Logo"
                        />
                    </Link>
                </div>

                <div className="app-sidebar__menu">
                    <AppSidebarMenu model={menuModel} />
                </div>

                <div className="app-sidebar__footer">
                    <div>© 2026 Alcolm AG</div>
                    <div>Version 2.0</div>
                </div>
            </div>
        </aside>
    );
};

export default AppSidebar;
